import React from 'react';

import cn from 'classnames';

import styles from '../Input.module.css';
import type { HTMLInputProps } from '../types';

/**
 * Basic input component that is only used to be rendered inside the specific input components
 * (e.g. NumberInput, TextInput, etc.)
 */
export const BasicInput = React.forwardRef<HTMLInputElement, HTMLInputProps>(
  ({ spellCheck = true, className, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(className, styles['input-component'])}
        spellCheck={spellCheck}
        {...rest}
      />
    );
  }
);

BasicInput.displayName = 'BasicInput';
